import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import React_logo from "../../Images/React_logo.png";
import Redux_logo from "../../Images/Redux_logo.png";
import JS_logo from "../../Images/JS_logo.png";
import dotNetCore_logo from "../../Images/dotNetCore_logo.png";
import cSharp_logo from "../../Images/cSharp_logo.png";
import sqlServer_logo from "../../Images/sqlServer_logo.png";
import aws_logo from "../../Images/aws_logo.png";
import gcp_logo from "../../Images/gcp_logo.png";
import azure_logo from "../../Images/azure_logo.png";
import jquery_logo from "../../Images/jquery_logo.png";
import bootstrap_logo from "../../Images/bootstrap_logo.png";
import sass_logo from "../../Images/sass_logo.png";
import tailwind_logo from "../../Images/tailwind_logo.png";
import css_logo from "../../Images/css_logo.png";
import html_logo from "../../Images/html_logo.jpg";
import nodejs_logo from "../../Images/nodejs_logo.png";
import mvc_logo from "../../Images/mvc_logo.png";
import vbDotNet_logo from "../../Images/vbDotNet_logo.png";
import aspDotNet_logo from "../../Images/aspDotNet_logo.png";
import ajax_logo from "../../Images/ajax_logo.png";
import webApi_logo from "../../Images/webApi_logo.png";
import jwt_logo from "../../Images/jwt.svg";
import mysql_logo from "../../Images/Mysql_logo.png";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";

const Container = tw.div`relative`;
const Column = tw.div`w-full mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12`,
  props.textOnLeft ? tw`md:mr-6 lg:mr-16 md:order-first` : tw`md:order-last`,
]);
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto pt-2 pb-0`;
const ImageRow = tw.div`flex flex-row md:flex-row justify-center max-w-screen-xl mx-auto pt-0 pb-0`;
const Description = tw.p`mt-8 text-justify md:text-justify sm:text-justify text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;
const ImageSpan = tw.span`lg:mx-5 md:mx-5 sm:mx-5 ml-1 mr-1`;
const Image = styled.img((props) => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
  tw(
    Column
  )`rounded-full bg-gray-200 w-32 p-4 sm:p-3 sm:w-24 lg:p-4 my-5 lg:w-32 md:w-24 md:p-3 xs:w-12 xs:p-1`,
]);
const Title = tw.p`-mt-4 text-sm text-center xs:mx-auto`;
const ImageColumn1 = tw(
  Column
)`rounded-full bg-gray-200 w-10 p-0 sm:p-3 sm:w-24 lg:p-2 mb-5 mt-3 lg:w-16 md:w-24 md:p-3 xs:w-18 xs:p-0 sm:items-start xs:items-start`;
const ImageColumn2 = tw(
  Column
)`rounded-full bg-gray-200 w-10 p-0 sm:p-3 sm:w-24 lg:p-2 mb-5 mt-3 lg:w-16 md:w-24 md:p-3 xs:w-18 xs:p-0 items-end sm:items-start xs:items-start`;

const RealEstateTechstack = (props) => {
  let subheading = "Our Expertise",
    heading = (
      <>
        Designed & Developed by{" "}
        <span tw="text-primary-500">Professionals.</span>
      </>
    ),
    description =
      "We build enterprise-critical web applications that are secure, high-performance, responsive and accessible. We are technology-agnostic and will provide impartial advise on the best technology stack. If you have legacy Microsoft applications to support and maintain, we have two decades of experience to ensure smooth operations and a graded upgrade path.",
    imageSrc = React_logo,
    imageSrc2 = Redux_logo,
    imageSrc3 = JS_logo,
    imageSrc4 = dotNetCore_logo,
    imageSrc5 = cSharp_logo,
    imageSrc6 = sqlServer_logo,
    imageSrc7 = aws_logo,
    imageSrc8 = gcp_logo,
    imageSrc9 = azure_logo,
    imageSrc10 = jquery_logo,
    imageSrc11 = bootstrap_logo,
    imageSrc12 = sass_logo,
    imageSrc13 = tailwind_logo,
    imageSrc14 = css_logo,
    imageSrc15 = html_logo,
    imageSrc16 = nodejs_logo,
    imageSrc18 = mvc_logo,
    imageSrc19 = vbDotNet_logo,
    imageSrc20 = aspDotNet_logo,
    imageSrc21 = ajax_logo,
    imageSrc22 = webApi_logo,
    imageSrc23 = sqlServer_logo,
    imageSrc24 = nodejs_logo,
    imageSrc25 = ajax_logo,
    imageSrc26 = jwt_logo,
    imageSrc27 = mysql_logo,
    imageRounded = true,
    imageBorder = false,
    imageShadow = false;

  return (
    <Container
      id={props.id}
      className={props.techstack === "pdf" ? "techstackPdf1" : ""}
    >
      <>
        {props.realestatepagepdf !== "pdf" && (
          <TextColumn>
            {/* <HighlightedText className="transform -skew-x-12">
            Techstack
          </HighlightedText> */}
            <SubHeadings heading1="Our" heading2="Techstack" />
          </TextColumn>
        )}
        <TwoColumn>
          <TextColumn>
            <div className="flex justify-center mt-2 py-4">
              <SubHeadings heading1="Backend" />
            </div>
            <div>
              <ImageRow>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc4}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="dotNetCore_logo"
                    />
                  </ImageColumn2>
                  <Title>.Net Core</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc5}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="cSharp_logo"
                    />
                  </ImageColumn2>
                  <Title>C Sharp</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc22}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="webApi_logo"
                    />
                  </ImageColumn1>
                  <Title>Web API</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc18}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="mvc_logo"
                    />
                  </ImageColumn2>
                  <Title>MVC</Title>
                </ImageSpan>
              </ImageRow>

              <ImageRow>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc20}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="aspDotNet_logo"
                    />
                  </ImageColumn1>
                  <Title>ASP.Net</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc19}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="VBDotNet_logo"
                    />
                  </ImageColumn1>
                  <Title>VB.Net</Title>
                </ImageSpan>
              </ImageRow>
            </div>
          </TextColumn>
          <TextColumn>
            <div className="flex justify-center mt-2 py-4">
              <SubHeadings heading1="Frontend" />
            </div>
            <div>
              {/* //2nd row */}
              <ImageRow>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="React_logo"
                    />
                  </ImageColumn2>
                  <Title>React</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc2}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="Redux_logo"
                    />
                  </ImageColumn2>
                  <Title>Redux</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc3}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="JS_logo"
                    />
                  </ImageColumn2>
                  <Title>Javascript</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc11}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="bootstrap_logo"
                      style={{ borderRadius: "50%" }}
                    />
                  </ImageColumn2>
                  <Title>Bootstrap</Title>
                </ImageSpan>
              </ImageRow>

              <ImageRow>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc10}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="jquery_logo"
                    />
                  </ImageColumn1>
                  <Title>Jquery</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc12}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="sass_logo"
                    />
                  </ImageColumn1>
                  <Title>SASS</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc13}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="tailwind_logo"
                    />
                  </ImageColumn1>
                  <Title>Tailwind CSS</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn1>
                    <Image
                      src={imageSrc14}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="css_logo"
                    />
                  </ImageColumn1>
                  <Title>CSS</Title>
                </ImageSpan>
              </ImageRow>

              <ImageRow>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc15}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="html_logo"
                    />
                  </ImageColumn2>
                  <Title>HTML</Title>
                </ImageSpan>
              </ImageRow>
            </div>
          </TextColumn>
        </TwoColumn>

        <TwoColumn>
          <TextColumn>
            <div className="flex justify-center py-4">
              <SubHeadings heading1="Server" />
            </div>
            <div>
              <ImageRow>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc23}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="sqlServer_logo"
                    />
                  </ImageColumn2>
                  <Title>SQL Server</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc24}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="nodejs_logo"
                    />
                  </ImageColumn2>
                  <Title>Node JS</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc25}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="ajax_logo"
                    />
                  </ImageColumn2>
                  <Title>AJAX</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc26}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="jwt_logo"
                    />
                  </ImageColumn2>
                  <Title>JWT</Title>
                </ImageSpan>
              </ImageRow>
              <ImageRow>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc27}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="mysql_logo"
                    />
                  </ImageColumn2>
                  <Title>My Sql</Title>
                </ImageSpan>
              </ImageRow>
            </div>
          </TextColumn>
          <TextColumn>
            <div className="flex justify-center py-4">
              <SubHeadings heading1="Cloud" />
            </div>
            <div>
              <ImageRow>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc7}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="aws_logo"
                    />
                  </ImageColumn2>
                  <Title>Amazon</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc9}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="azure_logo"
                    />
                  </ImageColumn2>
                  <Title>Microsoft</Title>
                </ImageSpan>
                <ImageSpan>
                  <ImageColumn2>
                    <Image
                      src={imageSrc8}
                      imageBorder={imageBorder}
                      imageShadow={imageShadow}
                      imageRounded={imageRounded}
                      alt="gcp_logo"
                    />
                  </ImageColumn2>
                  <Title>Google</Title>
                </ImageSpan>
              </ImageRow>
            </div>
          </TextColumn>
        </TwoColumn>
      </>
    </Container>
  );
};

export default RealEstateTechstack;
